import {IOrganization} from "../../interfaces/IOrganization";
import {Grid, Mui, AlertTypes} from "@leap4/frontend";
import React, {useEffect, useState} from "react";
import {setAlert} from "../../../../actions/alert";
import {PublisherLoginsAccess} from "./PublisherLoginsAccess";
import {organizationPartnersUrl} from "../../../../config/generals";
import Q from "bluebird"
import {ApiClient} from "../../../../utils/apiClient";
import _ from "lodash";

const {Button, Divider} = Mui;

export interface IPublisherLoginsProps {
    allOrganizations: Array<IOrganization>,
    updatePublisherLogins: (publisherLogins: IOrganizationPartners[]) => void, // function to update currentOrgPubLogins
    currentOrganization?: IOrganization // created\edited Organization

}

export interface IOrganizationPartners {
    org: IOrganization
    optionalPartners: string[] | {id: string, name: string}[],
    selectedPartners: string[],
    toSkipDiscrepancy: boolean
    facadeName: string
}

export const PublisherLoginsContainer = (props: IPublisherLoginsProps) => {
    const {allOrganizations, updatePublisherLogins, currentOrganization} = props
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const getInitialOrg = (publisherLogin?: {
        [organizationId: string]: {
            partners: string[],
            toSkipDiscrepancy: boolean
            facadeName: string
        }, // array of the supply partners ids
    }): IOrganizationPartners[] => {
        if (!publisherLogin || _.isEmpty(publisherLogin)) return [{org: null, optionalPartners: [], selectedPartners: [], toSkipDiscrepancy: true, facadeName: null}];
        return Object.entries(publisherLogin).map(([orgId, selectedPartners]) => {
            const theOrganization = allOrganizations.find(o => o._id.toString() === orgId)
            return {org: theOrganization, optionalPartners: selectedPartners.partners, selectedPartners: selectedPartners.partners, toSkipDiscrepancy: selectedPartners.toSkipDiscrepancy, facadeName: selectedPartners.facadeName}
        })
    }
    const initialSelectedOrganizations = getInitialOrg(currentOrganization.publisherLogin)
    const [selectedOrganizations, setSelectedOrganizations] = useState<IOrganizationPartners[]>(initialSelectedOrganizations);

    const isMoreOrganizations = () => {
        const _isMoreOrganizations = selectedOrganizations.length !== allOrganizations.length;
        if (_isMoreOrganizations) return {boolean: true, text: 'ADD PUBLISHER LOGIN'};
        return {boolean: false, text: 'NO MORE PUBLISHER LOGINS'}
    }
    const onAddOrganization = () => {
        if (selectedOrganizations.length === allOrganizations.length) return;
        const organizationPartners = [...selectedOrganizations, getInitialOrg()[0]]
        setSelectedOrganizations(organizationPartners);

    }

    const updateSelectedOrgs = async (id: string, previousId: string | undefined) => {
        const organizationToSet = allOrganizations.find(o => o._id === id);
        const organizationsToSet = [...selectedOrganizations]

        const optionalPartners = await getPartnersForOrganization(id)
        const previousIndex = selectedOrganizations.findIndex(o => o.org?._id === previousId)
        organizationsToSet[previousIndex] = {
            toSkipDiscrepancy: organizationsToSet[previousIndex].toSkipDiscrepancy,
            org: organizationToSet,
            optionalPartners,
            selectedPartners: organizationsToSet[previousIndex].selectedPartners || [],
            facadeName: organizationsToSet[previousIndex].facadeName || ''
        }
        setSelectedOrganizations(organizationsToSet)
    }

    const handleSkipChange = (forOrganizationId: string, skip: boolean) => {
        const copyOfSelectedOrgs = [...selectedOrganizations];
        const organizationToEditIdx = copyOfSelectedOrgs.findIndex(sO => sO.org._id === forOrganizationId);
        copyOfSelectedOrgs[organizationToEditIdx].toSkipDiscrepancy = skip;
        setSelectedOrganizations(copyOfSelectedOrgs)
    }

    const handlePartnersChange = (chosenPartners: string[], forOrganizationId: string) => {
        const copyOfSelectedOrgs = [...selectedOrganizations];
        const organizationToEditIdx = copyOfSelectedOrgs.findIndex(sO => sO.org._id === forOrganizationId);
        copyOfSelectedOrgs[organizationToEditIdx].selectedPartners = chosenPartners;
        setSelectedOrganizations(copyOfSelectedOrgs)
    }

    const handleFacadeNameChange = (facadeName: string, forOrganizationId: string) => {
        const copyOfSelectedOrgs = [...selectedOrganizations];
        const organizationToEditIdx = copyOfSelectedOrgs.findIndex(sO => sO.org._id === forOrganizationId);
        copyOfSelectedOrgs[organizationToEditIdx].facadeName = facadeName
        setSelectedOrganizations(copyOfSelectedOrgs)
    }

    const handleOrganizationRemove = (orgIdToRemove: string) => {
        const newSelectedOrgs = selectedOrganizations.filter(o => o.org?._id !== orgIdToRemove);
        setSelectedOrganizations(newSelectedOrgs)
    };

    const fetchOptionalPartners = async () => {
        const newSelectedOrgs: IOrganizationPartners[] = await Q.map(selectedOrganizations, async (o, idx) => {
            const optionalPartners = await getPartnersForOrganization(o?.org._id)
            return {...o, optionalPartners}
        })
        setSelectedOrganizations(newSelectedOrgs)
    }

    const getPartnersForOrganization = async (orgId: string) => {
        setIsLoading(true)
        try {
            const allData =  (await ApiClient.get(organizationPartnersUrl, {params: {organization: orgId.toString()}})).data;
            if (!allData || !allData?.length) {
                return [{id: "", name: ""}]
            }
            return allData;
        } catch (err) {
            setAlert(`Couldn't load Partners, err is: ${err}`, AlertTypes.FAILURE)

        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (selectedOrganizations.some(o => !o?.org?._id)) return;
        if (selectedOrganizations.some(s => !s.optionalPartners?.length || typeof s.optionalPartners[0] === 'string')) {
            fetchOptionalPartners()
        }
        updatePublisherLogins(selectedOrganizations)
    }, [selectedOrganizations]);

    const allSelectedOrgIds = selectedOrganizations.map(o => o.org?._id)
    return (
        <>
            <Grid margin={"30px"}>
                <h1>Publisher Logins</h1>
                <Divider/>
            </Grid>
            <Grid item xs={2} margin={"10px"} >
                Access to
            </Grid>
            {
                selectedOrganizations
                    .map((sO, idx) => {
                    const availableOrganizations = allOrganizations
                        .filter(org => (allSelectedOrgIds.indexOf(org._id) === -1 && org._id) && org._id !== currentOrganization._id)
                    sO.org?._id && availableOrganizations.unshift(sO.org)
                    return <PublisherLoginsAccess organization={sO}
                                                  isLoading={isLoading}
                                                  handleSkipChange={handleSkipChange}
                                                  availableOrganizations={availableOrganizations}
                                                  onUpdateSelectedOrgs={updateSelectedOrgs}
                                                  onPartnersChange={handlePartnersChange}
                                                  onOrganizationRemove={handleOrganizationRemove}
                                                  key={sO?.org?._id ?  sO?.org?._id + currentOrganization._id : idx + Math.random()}
                                                  onFacadeNameChange={handleFacadeNameChange}
                    />})
            }
            <Grid item xs={2.2}>
            <Button size="medium" variant="contained" color="primary"
                    disabled={!isMoreOrganizations().boolean}
                    onClick={onAddOrganization}>
                {isMoreOrganizations().text}
            </Button>
            </Grid>
        </>
    )
}



